import { Doc } from "@cvx/_generated/dataModel";

export const UGC_AGREEMENT_TEMPLATE = `**SOCIAL MEDIA AND INFLUENCER SERVICES AGREEMENT**
between
**[COMPANY NAME]**
and
**[CREATOR NAME]**

THIS AGREEMENT ("Agreement") is made with effect from [EFFECTIVE DATE] ("Effective Date")

BETWEEN:
1. [COMPANY NAME] is a company registered in [COMPANY JURISDICTION] with registered company number ______________________________ and whose registered office is at __________________________________________ ("Company"); and

2. [CREATOR NAME] of __________________________________________ ("Talent")

Talent and Company may be individually referred to in this Agreement as a "Party" and together as "Parties".

**BACKGROUND:**
The Company wishes to engage Talent to provide certain services with respect to the Brand and Talent has agreed to provide those services in accordance with the terms and conditions as set out in this Agreement (being the Commercial Terms and Terms and Conditions (as set out at Appendix 1)).

**COMMERCIAL TERMS**

**Brand**
[BRAND NAME]

**Project**
[PROJECT TYPE]

**Term**
The Term shall commence on the Effective Date and (subject to earlier termination in accordance with the terms of this Agreement) shall expire on when the last Deliverable is posted on the Media.

**Fee**
In consideration of the full and complete provision of the Services, Company shall pay to Talent the sum of $[BASE FEE] and $[CPM RATE] CPM variable.

[CPM PAYMENT REQUIREMENT]

All sums payable under this Agreement are inclusive of Value Added Tax ("VAT")

**Payment Schedule**
The Base Fee shall be paid by Company to Talent upon delivery and final approval of all Deliverables.

The total CPM-based variable fee, if applicable, shall be paid [CPM PAYMENT PERIOD] days after the final Deliverable is posted, based on the organic view count across all Deliverables.

Unless otherwise agreed in writing by the Parties, all sums payable by Company to Talent in accordance with this Agreement shall be paid within [PAYMENT TERMS] days of the date of Talent's invoice.

**Services**
The Services shall be exclusive and shall be comprised of the following:

Talent shall create [NUMBER OF DELIVERABLES] Deliverable(s).

[PARTNERSHIP_TYPE_PUBLISHING_PROCESS]

**Deliverable(s)**
Company shall provide Talent with creative direction, content guidelines, and video examples at the start of the project to support delivery.

Talent shall deliver [NUMBER OF DELIVERABLES] short-form videos over [DELIVERY PERIOD], [DELIVERY SCHEDULE], unless otherwise agreed in writing.

CPM-based variable compensation will be calculated based on the total organic views across all Deliverables, measured [CPM PAYMENT PERIOD] days after posting on Company-owned accounts.

Company retains full usage rights for the content, including the right to repost, promote, or boost the Deliverables. Any paid promotion or boosting will not count toward the CPM view calculations.

**Exclusivity**
Talent may not, without the prior written permission of the Company, promote any other brands save for the Brand within the Deliverable(s). Under no circumstances may Talent promote, endorse or provide services to any Competing Brand for the duration of the Term. For the purpose of this Agreement, a "Competing Brand" shall mean any third party which could reasonably be considered a direct or indirect competitor of the Brand.

This Agreement (which comprises the Commercial Terms and all annexed Appendices, including but not limited to the Terms and Conditions) sets out the terms and conditions upon which the Talent shall provide the Services (as defined below) to Company.

The Parties have indicated their acceptance of this Agreement by signing below. Whether or not Company says this Agreement, Company's continued instructions in relation to the Services and/or Deliverable(s) shall amount to Company's acceptance of the terms of this Agreement.

SIGNED by Talent

_________________________________
Print name: [CREATOR NAME]
Date: [CREATOR SIGNATURE DATE]



SIGNED for and on behalf of [COMPANY NAME]

_________________________________
Print name: [FOUNDER NAME]
Date: [FOUNDER SIGNATURE DATE]





**TERMS AND CONDITIONS**

**1. DEFINITIONS AND INTERPRETATION**

1.1. In this Agreement, capitalised terms shall have the meanings ascribed to them in the Commercial Terms or as set out below or otherwise as set out in these Terms and Conditions, as applicable:

**"Advertising Regulations"**
means all applicable laws, regulations, codes of practice, guidelines, decisions and orders imposed by law or any competent regulatory authority in any jurisdiction relating to advertising and/or marketing and/or consumer protection, including without limitation those regulations and codes of practice promulgated by the Competition and Markets Authority (CMA) and the Advertising Standards Authority (ASA);

**"Applicable Laws"**
means all applicable laws, statutes, regulations and codes from time to time in force, including without limitation all applicable Data Protection Laws and Advertising Regulations;

**"Associates"**
means a Party's employees, officers, agents, subcontractors or authorised representatives;

**"Business Day"**
means any day other than a Saturday, Sunday or public holiday in [COMPANY JURISDICTION];

**"Company Materials"**
means any Materials or information owned by or licensed to Company that is provided to Talent and/or any of its respective Associates by or on behalf of Company in connection with this Agreement;

**"Data Protection Laws"**
means all applicable data protection laws, regulations and codes in force from time to time in any jurisdiction, including without limitation Regulation (EU) 2016/679 (The General Data Protection Regulation), the Data Protection Act 2018, any replacement legislation, and any guidance and codes of practice issued by data protection regulators

**"Talent Materials"**
means Materials created by Talent and/or any of its respective Associates by or on its behalf in connection with the Services (including any Materials adapted, modified or derived from the Company Materials) and irrespective of whether or not the same are incorporated into the Deliverable(s);

**"Image Rights"**
means all rights in and to the registered or unregistered trademarks, name, nickname, likeness, image, picture, voice, signature, autograph, signifier, avatar, logo, animated representation or other identification, statements, quotations and biographical or other details, associated fame, reputation and goodwill associated with Talent.

**"Intellectual Property Rights"**
means any and all present and future, patents, inventions, know-how, trade secrets and other confidential information, trademarks, service marks, logos, emblems, badges, mascots, insignia, identifying music and sounds, get-up, domain names, business names, trade names, moral rights, performance rights, registered designs, copyrights, database rights, the sui generis rights of extraction relating to databases, design rights and other intellectual property rights of whatever nature, in each case whether registered or unregistered and including applications for registration, and all rights or forms of protection having equivalent or similar effect anywhere in the world;

**"Materials"**
means any artwork, copy, designs, photographs, audio-visual content, performance and/or any other material protected by Intellectual Property Rights.

2. References in this Agreement to:

2.1. any statute or statutory provision include references to that statute or statutory provision as from time to time amended, extended or re-enacted and to any rules, orders, regulations and delegated legislation made thereunder;

2.2. "person(s)" shall include any individual, firm, company, association, corporation or other organisation or entity; and

2.3. "including" and related expressions shall mean "including, without limitation".

3. The headings in this Agreement do not affect its interpretation.

**4. Engagement**

4.1. Talent shall provide the Services in accordance with the terms of this Agreement and using all reasonable skill and care. Talent acknowledges and agrees that Company is not obliged to use the Deliverable(s).

**5. The Fee**

5.1. Subject to the full and complete provision of the Services by Talent, the Fee will be invoiced to and paid by Company to Talent in accordance with the Commercial Terms.

5.2. Talent shall be responsible for making all deductions from payments and fees received hereunder and performing all acts and making all payments necessary under any legislation in force in [COMPANY JURISDICTION]. For the avoidance of doubt, Company shall not make such deductions from the Fee.

**6. Expenses & Travel**

Where applicable, Company shall pay or reimburse Talent for all reasonable travel, accommodation and subsistence expenses properly incurred by Talent and/or Talent's Associates in performing the Services as evidenced by receipts provided such expenses have been prior-approved by the Company in writing.

**7. Editorial Control**

7.1. Talent acknowledges that amongst other things, the provision of the Services and the posting and use of the Deliverable(s) across the relevant Media in relation to the Project are subject to the Advertising Standards Authority Guidelines, the Committee of Advertising Practice Code ("CAP Code") as well as Consumer Protection legislation (and the requirements of the Competition & Markets Authority). Talent shall ensure that the Deliverable(s) will be compliant with the CAP Code and Consumer Protection legislation.

7.2. Talent shall ensure that the Deliverable(s) are posted in accordance with the Applicable Laws on the Media and shall be disclosed to viewers as being paid for content/advertising in accordance with the Advertising Regulations, including but not limited to the CAP Code by using appropriate disclosures such as 'AD' or '#AD' in a clear and prominent manner.

7.3. Company agrees to give Talent clear briefings so that Talent is able to fulfil its obligations under this Agreement. Company will promptly supply to Talent (at no charge) any Company Materials reasonably required by Talent to provide the Services.

**8. Warranties & Undertakings**

8.1. Talent hereby warrants and undertakes that:

8.1.1. it is able to provide the Services and has the legal capacity to enter into this Agreement;

8.1.2. it has the necessary skills and knowledge to carry out the Services under this Agreement;

8.1.3. owns and controls the Image Rights and has not assigned or transferred its rights in the Image Rights to any third party (including any so-called 'image rights company');

8.1.4. has not entered into any agreement or arrangement which: (i) conflicts with Company's rights under this Agreement; or (ii) will interfere with the Talent's performance of this Agreement;

8.1.5. will not be in breach of any agreement with any third party by reason of entering into and performing this Agreement;

8.1.6. has obtained all permissions, waivers and consents from any third party necessary to enter into and perform this Agreement;

8.1.7. will co-operate with the Company in all matters relating to the Services and comply with all reasonable instructions given by the Company in relation to the same;

8.1.8. will keep the Company informed of all relevant matters relating to the Services (including without limitation any prior professional commitments insofar as the same may impact upon the terms of this Agreement);

8.1.9. shall not use the Company Materials in a manner or context which:
1. may devalue, impair or adversely affect the Company;
2. implies or suggests a commercial relationship between Company and any other person, brand or entity; or
3. is reasonably regarded as obscene, illegal, misleading, defamatory, derogatory or disparaging of the Company or the Talent, or in a way which might bring the Talent or Company or the Project into public disrepute;

8.1.10. will not do (or omit to do) anything or adopt a stance which is intended to or does in any way circumvent or is otherwise contrary to the Parties' intentions as contained herein;

8.1.11. the Services shall be provided in accordance with the Commercial Terms (and as otherwise set out herein) and such Services shall be provided with all due care, skill and ability;

8.1.12. Deliverable(s) (excluding Company Materials) will not, when used in accordance with this Agreement, infringe the Intellectual Property Rights or other rights of any third party and will comply with all Applicable Laws; and

8.1.13. unless prevented by ill health or accident, to devote such time as is necessary to the carrying out of the Services as may be necessary for their proper performance.

8.2. If Talent is unable to provide the Services due to illness, injury or other emergency, Talent shall advise the Company of that fact immediately.

8.3. Company warrants, represents and undertakes that:

8.3.1. it has full power and authority to enter into this Agreement and that by doing so it will not be in breach of any obligation or right of a third party;

**9. Intellectual Property Rights**

9.1. Talent acknowledges that ownership of Company Materials and ownership of all Intellectual Property Rights and any related goodwill in and to the same remain vested in Company or its licensors. Company hereby grants to Talent a non-exclusive, revocable licence during the Term to use the Company Materials solely for the purposes of providing the Services and creating and exploiting the Deliverable(s) as provided for herein.

9.2. All copyright and related rights, patents, rights to inventions, trade marks, trade names and domain names, rights in get-up, rights in goodwill or to sue for passing off, rights in designs, rights in computer software, database rights, rights in confidential information (including know-how and trade secrets) and any other intellectual property rights, in each case whether registered or unregistered and including all applications (or rights to apply) for, and renewals or extensions of, such rights and all similar or equivalent rights or forms of protection which may now or in the future subsist in any part of the world ("Intellectual Property Rights") in the Deliverables and the results of the Talent services carried out for the Company in connection with this Agreement shall belong to and vest in the Company on creation and the Talent agrees to do all things required by the Company for such Intellectual Property Rights to so vest in the Company.

9.3. The Talent assigns to the Company, with full title guarantee and including by way of present assignment of past, present and future copyright (if applicable), all Intellectual Property Rights in the Deliverables and all materials produced pursuant or preparatory thereto. That includes the exclusive right to do and to authorise others to do any and all acts in relation to the Deliverables throughout the world in perpetuity in any media together with all rights of action in respect of any past or existing infringements of such Intellectual Property Rights by any third party.

9.4. The Talent also hereby waives any so called moral rights, rights of authors and any similar rights and therefore grants to the Company total and unlimited rights to use, modify and adapt the Deliverables and Talent Image Rights as included within the Deliverables for all purposes and in any manner the Company thinks fit. The Company shall also be entitled to use the Talent Image Rights in connection with the use of the Deliverables.

9.5. All equipment, content and materials supplied by the Company in connection with the Deliverables to the Talent and all Intellectual Property Rights therein will belong to and vest in Company (or Company licensor) and Talent is loaned and/or granted a non-exclusive licence to use them solely as necessary for the purpose of this Agreement and the provision of the Deliverables hereunder. The Talent agrees that the Talent will not use the foregoing for any purpose other than for the purpose of this Agreement and the provision of the Deliverables hereunder and that following completion of the Deliverables the Talent will return the same to the Company and cease all and any use thereof unless agreed by the Company in writing.

9.6. In the event of any dispute relating to the subject matter of this Agreement, including with respect to the exploitation of any Intellectual Property Rights in and to the Deliverable(s), Talent Material(s) and/or any results and proceeds of Talent's contribution through its Services, such remedy of Talent shall be limited to monetary damages, if any, actually sustained by Talent. In no event will Talent be entitled by reason of breach or default to revoke, terminate, or rescind or alter this Agreement or to enjoin or restrain Company's distribution or advertising of the Project or Company's exploitation of the Deliverable(s) in connection with the Project, Talent Material(s) and or any Image Rights as may be comprised therein, or to obtain or seek to obtain any equitable remedies whatsoever against Company.

**10. Termination**

10.1. Either Party may terminate the Term of this Agreement immediately upon written notice to the other in the event of:

10.1.1. any breach of this Agreement by the other Party which breach is not remediable or, if remediable, is not remedied within fourteen (14) days after the service by the Party not in default of a written notice on the other Party, specifying the nature of the breach and requiring that the same be remedied; or

10.1.2. the other Party becoming insolvent, entering into liquidation, whether voluntary or compulsory, passing a resolution for its winding up, having a receiver or administrator appointed over the whole or any part of its assets, making any composition or arrangement with its creditors or taking or suffering any similar action in consequence of its debt.

10.2. On termination of the Term of this Agreement:

10.2.1. Company shall pay to Talent any amount due under this Agreement up to the date of the event giving rise to termination save where the termination of the Term is by virtue of a breach by Talent whereby Talent shall reimburse the Company for any Fees already paid to Talent and Company's expenses incurred in procurement of Talent's Services;

10.2.2. each Party shall immediately deliver to, or dispose of as directed by, the other Party any and all materials and property belonging or relating to the other Party, including all confidential information, and all copies of the same, then in its possession, custody or control; and

10.2.3. provisions of this Agreement which either are expressed to survive its termination or from their nature or context it is contemplated that they are to survive such termination, shall remain in full force and effect notwithstanding such termination.

10.3. Notwithstanding termination or expiration of the Term of this Agreement for any reason each Party will remain entitled to enforce any claim against the other Party arising from any breach of this Agreement that may have occurred before the termination.

**11. Liability**

11.1. Subject to sub-Clause 11.2, Company's maximum aggregate liability under or in connection with this Agreement (including any indemnity contained in this Agreement), whether in contract, tort (including negligence) or otherwise, shall in no circumstances exceed the level of the Fee actually due to the Talent as at the date the relevant liability arose.

11.2. Company shall not be liable for any loss of actual or anticipated income or profits, loss of goodwill or reputation or for any special, indirect or consequential loss or damage of any kind howsoever arising whether or not such loss or damage is foreseeable, foreseen or known SAVE THAT nothing in this Agreement shall exclude or in any way limit either Party's liability for fraud, death or personal injury caused by its negligence or any other liability to the extent the same may not be excluded or limited as a matter of law.

11.3. Talent agrees to indemnify and keep the Company indemnified against any or all losses incurred by the Company arising from any breach by Talent of this Agreement.

11.4. The terms of and obligations imposed by clauses 11.1 to 11.3 shall survive the termination of the Term of this Agreement for any reason.

**12. Confidentiality and Non-Disparagement**

12.1. The Parties acknowledge that the terms of this Agreement are confidential and must not be disclosed to any third party, excluding agents and representatives, or to otherwise enforce the provisions hereto. Neither Party shall make any press announcements regarding this Agreement without the other Party's prior written consent, except as required by law.

12.2. Certain Confidential Information may come into either Party's possession as a result of the Services provided hereunder. For the purposes of this Agreement "Confidential Information" shall mean any information, data, spoken words, documentation, photographs, images, audio and audio visual recordings relating to the services or to the business, personal affairs, properties, assets, activities and/or health of Talent and/or any of its Associates or any member of their family or any of their companies, including any information which although not strictly confidential in a legal sense may be of interest or value to, amongst others, the press or gossip writers. Each Party agrees to treat as confidential and private any and all Confidential Information disclosed to or observed by either Party in connection with, or as a result of, this Agreement and/or the provision of Services as anticipated hereunder. Each Party further agrees that, except with the other Party's prior written consent and/or unless required by law and under no circumstances otherwise, neither Party will disclose the Confidential Information or any part thereof to any third party. Furthermore, both Parties agree that they will not themselves or through third parties or agents, disparage or ridicule the other Party and/or any of its Associates, their products, work product, services, Associates, agents, representatives and/or employees.

12.3. Talent and/or any of its Associates agree not, either personally or by other means, to make any statement or disclose any confidential information to any third party relating to the Deliverable(s) or the general affairs of Company, unless Company gives its prior written consent.

12.4. The Talent shall ensure that the Talent conducts itself with regard to public morals and conventions and shall not commit any act or omission which might bring Company and/or any of its Associates (whether through their collaboration with the Talent or otherwise) into public disrepute, contempt, scandal or ridicule, or which might tend to injure the success of Company and/or any of its Associates or which may harm the reputation of Talent and/or any of its Associates and not make any defamatory or derogatory statements about, or take part in any activities which are or might reasonably be perceived to be derogatory of or detrimental to the reputation of the Company and/or any of its Associates.

**13. Force Majeure**

Neither Party shall be in breach of this Agreement nor liable for delay in performing, or failure to perform, any of its obligations under this Agreement if such delay or failure result from events, circumstances or causes beyond its reasonable control (a "Force Majeure Event"). In such circumstances the affected Party shall be entitled to a reasonable extension of the time for performing such obligations. If the period of delay or non-performance continues for a period of more than one (1) month, the Party not affected may terminate the Term of this Agreement by giving fourteen (14) days' written notice to the affected Party.

**14. Notices**

14.1. Any notice to be given to a Party under or in connection with this Agreement shall be in writing and shall be: (i) by email; or (ii) delivered by hand or by pre-paid first-class post or other next working day delivery service at its registered office (if a company) or its principal place of business (in any other case).

14.2. Any notice shall be deemed to have been received:

14.2.1. if delivered by email, on the date it was sent and received by the recipient;

14.2.2. if delivered by hand, on signature of a delivery receipt or at the time the notice is left at the proper address; or

14.2.3. if sent by pre-paid first-class post or other next working day delivery service, at 9.00 am on the second Business Day after posting or at the time recorded by the delivery service.

**15. MISCELLANEOUS**

15.1. Nothing contained herein shall be deemed to constitute or create a partnership or joint venture between the Parties and neither Party shall hold itself out as the agent of the other.

15.2. No waiver by the Parties or any failure by them to perform any covenant or condition herein shall be deemed to be a waiver of any preceding or succeeding breach of any covenant or condition herein.

15.3. If any clause or any part of these terms or their application to any Party shall for any reason be adjudged by a court or other legal authority of competent jurisdiction to be invalid, this judgment shall not affect the remainder of the terms which shall remain in full force and effect.

15.4. This Agreement represents the entire agreement between the Parties in respect of its subject matter and replaces any previous agreement(s) relating to the subject matter and may be varied only in writing signed by the Parties.

15.5. This Agreement may be executed in any number of counterparts by signature, by a Party affixing their respective electronic signature hereto by means of typing or an electronic signature system, or otherwise by a Party indicating their intention in writing on this Agreement to be bound by it. Each counterpart (including those in electronic form) which is so executed, will be an original, but together all counterparts will constitute one and the same instrument. Transmission of the executed signature page of a counterpart of this Agreement (a) by fax, (b) by email (in PDF, JPEG or other agreed format) or (c) by the above-mentioned electronic signature system shall take effect as delivery of an executed counterpart of this Agreement. If either method of delivery is adopted, without prejudice to the validity of the Agreement thus made, either Party can request from the other that the original of such counterpart be provided as soon as reasonably possible thereafter.

15.6. Both Parties hereby agree to promptly execute such further documents or agreements as may reasonably be required to confirm the grant of rights hereunder and further each Party agrees to afford the other all reasonable assistance to protect the rights hereunder granted hereunder.

15.7. Talent may not assign, transfer, license, sub-licence, charge, mortgage or otherwise all and/or any of their rights herein in whole or in part without the prior written consent of the Company.

15.8. This Agreement shall be governed and construed in accordance with the laws of [GOVERNING LAW] and the courts of [GOVERNING LAW] shall be the exclusive courts of competent jurisdiction.

15.9. For the purposes of the Contracts (Rights of Third Parties) Act 1999 no term or condition herein shall confer or be construed as conferring any right on any third party.
`;

// Contract data interface for prefilling templates
interface ContractData {
  campaign: Doc<"campaigns"> | undefined;
  contract: Doc<"creatorContracts">;
  app: Doc<"apps">;
  creator: {
    name?: string;
    email?: string;
  };
  founder: {
    name?: string;
  };
}

// Function to prefill template with contract data
export function prefillUGCTemplate(data: ContractData): string {
  const { contract, app, creator, founder, campaign } = data;

  let template = UGC_AGREEMENT_TEMPLATE;

  // Helper function to format date
  const formatDate = (timestamp: number): string => {
    return new Date(timestamp).toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  // Company and Creator info
  template = template.replace(/\[COMPANY NAME\]/g, app.name);
  template = template.replace(/\[BRAND NAME\]/g, app.name);
  template = template.replace(
    /\[CREATOR NAME\]/g,
    creator.name || "Creator Name",
  );
  template = template.replace(
    /\[FOUNDER NAME\]/g,
    founder.name || "Founder Name",
  );

  // Dates
  template = template.replace(
    /\[EFFECTIVE DATE\]/g,
    formatDate(contract.startDate),
  );
  template = template.replace(/\[CREATOR SIGNATURE DATE\]/g, "_____________");
  template = template.replace(/\[FOUNDER SIGNATURE DATE\]/g, "_____________");

  // Company details (defaults)
  template = template.replace(/\[COMPANY JURISDICTION\]/g, "England and Wales");
  template = template.replace(
    /\[COMPANY NUMBER\]/g,
    "[Company Registration Number]",
  );
  template = template.replace(
    /\[PROJECT TYPE\]/g,
    campaign?.type === "influencer"
      ? `Creation of UGC Content for ${app.name} to be posted on ${creator.name}'s social media accounts.`
      : `Creation of UGC Content for ${app.name} to be posted on ${app.name}-owned social media accounts.`,
  );
  template = template.replace(
    /\[COMPANY ADDRESS\]/g,
    "[Company Registered Address]",
  );
  template = template.replace(/\[CREATOR ADDRESS\]/g, "[Creator Address]");
  template = template.replace(
    /\[PARTNERSHIP_TYPE_PUBLISHING_PROCESS\]/g,
    campaign?.type === "influencer"
      ? "The Deliverable(s) shall be sent to Company for review and approval before publishing. Company shall have the right to request revisions and must provide final approval before any content is published."
      : "The Deliverable(s) shall be posted directly by Talent on their social media accounts. Talent agrees to track and report these posts through the Company's platform for performance monitoring.",
  );

  // Financial terms
  let baseFee = "0"; // default
  let cpmRate = "0"; // default
  let minimumViews = "0"; // default
  let cpmPaymentPeriod = "0"; // default
  const paymentTerms = "30"; // default

  // Extract financial data from contract
  if (contract.flatFee?.perVideo) {
    baseFee = contract.flatFee.perVideo.toString() + " per video";
  }

  if (contract.flatFee?.timePeriod) {
    baseFee =
      contract.flatFee.timePeriod.amount +
      " every " +
      contract.flatFee.timePeriod.days +
      " days";
  }

  if (contract.cpmRate) {
    if (
      contract.cpmRate.type === "totalViews" ||
      contract.cpmRate.type === "perVideo"
    ) {
      cpmRate = contract.cpmRate.rate.toString();
      minimumViews = contract.cpmRate.threshold.toLocaleString();
      cpmPaymentPeriod = contract.cpmRate.cutoffPeriod.toString();
    }
  }

  template = template.replace(/\[BASE FEE\]/g, baseFee);
  template = template.replace(/\[CPM RATE\]/g, cpmRate);
  template = template.replace(/\[MINIMUM VIEWS\]/g, minimumViews);
  template = template.replace(
    /\[CPM PAYMENT REQUIREMENT\]/g,
    contract.cpmRate?.type === "totalViews"
      ? `The CPM-based payment will only apply if the Deliverables achieve a minimum of ${minimumViews} organic views across all videos posted.`
      : `The CPM-based payment will only apply for Deliverables that achieve a minimum of ${minimumViews} organic views per video.`,
  );
  template = template.replace(/\[CPM PAYMENT PERIOD\]/g, cpmPaymentPeriod);
  template = template.replace(/\[PAYMENT TERMS\]/g, paymentTerms);

  // Project details
  let numberOfDeliverables = "0"; // default
  let deliveryPeriod = ""; // default
  let deliverySchedule = ""; // default

  if (contract.requiredVideos) {
    const { count, duration } = contract.requiredVideos;
    const contractDurationInDays = Math.ceil(
      (contract.endDate - contract.startDate) / (1000 * 60 * 60 * 24),
    );
    const numberOfPeriods = Math.ceil(contractDurationInDays / duration);
    const totalRequired = numberOfPeriods * count;

    numberOfDeliverables = totalRequired.toString();
    deliveryPeriod = `a ${contractDurationInDays}-day period`;

    // Calculate delivery schedule
    const videosPerWeek = Math.ceil(
      (totalRequired / contractDurationInDays) * 7,
    );
    const weeks = Math.ceil(contractDurationInDays / 7);
    deliverySchedule = `${videosPerWeek} video${videosPerWeek !== 1 ? "s" : ""} per week for ${weeks} week${weeks !== 1 ? "s" : ""}`;
  }

  template = template.replace(
    /\[NUMBER OF DELIVERABLES\]/g,
    numberOfDeliverables,
  );
  template = template.replace(/\[DELIVERY PERIOD\]/g, deliveryPeriod);
  template = template.replace(/\[DELIVERY SCHEDULE\]/g, deliverySchedule);

  // Legal defaults
  template = template.replace(/\[GOVERNING LAW\]/g, "England and Wales");

  return template;
}

export const CONTRACT_TEMPLATES = {
  UK: {
    name: "UGC Creator Agreement",
    description: "Comprehensive UGC agreement with CPM-based compensation",
    content: UGC_AGREEMENT_TEMPLATE,
    prefill: prefillUGCTemplate,
  },
};
